import { 
    IMutations,
    IMutationsTrackerResponsePayload
} from './mutations.types'
import { ITracker } from '@/entities'
import { AppConstants as _app } from '@/shared/app.constants'

export const mutations: IMutations = {
    
    /** refresh the state with the tracker info */
    setTracker(state: ITracker, payload: IMutationsTrackerResponsePayload): void {        
        state.template = payload.trackerResp.Template;
        state.tracker = payload.trackerResp.TrackerData;
        state.selectedKey = state.selectedKey || Object.keys(payload.trackerResp.Template.properties)[0];
        state.grantInfo = this.$services.grant.formatGrantInfo(payload.trackerResp.GrantInfo);
        if(payload.trackerResp.MappedStories)
        {
            state.MappedStories=payload.trackerResp.MappedStories;
        }    
        if(payload.trackerResp.CommunicationTemplate) {
            state.steps = payload.trackerResp.CommunicationTemplate["x-childSteps"];
        }
    }    

}